import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

export const ProjectsListItem = ({ title, selected, setProjectsGroup, icon: Icon }) => {
	return (
		<ListItemButton selected={selected} onClick={() => setProjectsGroup()} sx={{ paddingInline: "8px" }}>
			<ListItemIcon sx={{ minWidth: "32px" }}>
				<Icon />
			</ListItemIcon>
			<ListItemText primary={title} />
		</ListItemButton>
	);
};
